import React, { useState } from 'react';
import LanguageDropdown from '@components/LanguageDropdown';
import { Box } from '@mui/material';

const TNC: React.FC = () => {
  const [currentLanguage, setCurrentLanguage] = useState<string>('zh');
  const timestamp: number = Date.now();

  return (
    <Box sx={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      <LanguageDropdown currentLanguage={currentLanguage} changeLanguage={setCurrentLanguage} />
      <iframe
        src={
          currentLanguage === 'zh'
            ? `https://cms.hkstylist.com/商戶條款及細則/?t=${timestamp}`
            : `https://cms.hkstylist.com/business-terms-and-conditions/?t=${timestamp}`
        }
        title="Terms and Conditions"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
    </Box>
  );
};

export default TNC;
